import { Box, IconButton } from '@mui/material';

import { CloseIcon } from 'modules/common/icons';

interface INotificationCloseProps {
  onClick?: () => void;
}

export function NotificationClose({
  onClick,
}: INotificationCloseProps): JSX.Element {
  return (
    <IconButton
      onClick={onClick}
      sx={{
        position: 'absolute',
        top: '14px',
        right: theme => theme.spacing(1),
      }}
    >
      <Box component={CloseIcon} width={16} sx={{ color: 'customMain.600' }} />
    </IconButton>
  );
}
